export default __webpack_public_path__ + "static/media/graph-icon.36fed726.webp";